import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./customizeSpotTheme.css";
import { fetchThemeData } from "../../themeSlice";
import { selectAdminToken } from "../../sessionSlice";
import BadgeCategoryEditor from "./BadgeCategoryEditor";

const CustomizeSpotTheme = () => {
  const dispatch = useDispatch();
  const adminToken = useSelector(selectAdminToken);
  const { currentTheme, data } = useSelector((s) => s.theme);

  useEffect(() => {
    if (currentTheme) dispatch(fetchThemeData({ themeId: currentTheme }));
  }, [dispatch, currentTheme]);

  return (
    <div className="catmgr-page" data-tour="customize-spot">
      <BadgeCategoryEditor
        data={data}
        currentTheme={currentTheme}
        adminToken={adminToken}
      />
    </div>
  );
};

export default CustomizeSpotTheme;
